import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { useLogin } from "./useLogin";
import { getTitle } from "../../functions/helperMethod";
import {
  deleteWorkingDocument,
  clearDeleteWorkingDocumentState,
} from "../slices/documents/deleteWorkingDocumentSlice";

export function useDeleteWorkingDocument() {
  const dispatch = useAppDispatch();
  const { teamsContext } = useLogin();
  const state = useAppSelector(
    (rootState) => rootState.DocumentsSlice?.deleteWorkingDocument,
  );

  const deleteDocument = useCallback(
    async (document) => {
      if (!document) return;
      if (!teamsContext) {
        throw new Error("Teams context is not available");
      }

      const isGeneralApp = !teamsContext.channel?.id;
      const membershipType = teamsContext.channel
        ? teamsContext.channel.membershipType
        : "Regular";
      const teamId =
        teamsContext.channel?.membershipType === "Private"
          ? teamsContext.channel.ownerGroupId
          : teamsContext.team?.groupId ?? "";
      const oneDriveRoot = isGeneralApp ? "MainMenu" : "ChannelDoc";

      const fileId =
        document.id ?? document.documentId ?? document.ItemsId ?? "";

      if (!fileId) {
        throw new Error("File id is missing for delete operation");
      }

      const documentDisplayName =
        getTitle(document?.title ?? document?.name ?? "Document");

      return dispatch(
        deleteWorkingDocument({
          fileId,
          teamId,
          membershipType,
          oneDriveRoot,
          documentDisplayName,
        }),
      ).unwrap();
    },
    [dispatch, teamsContext],
  );

  const clearState = useCallback(
    () => dispatch(clearDeleteWorkingDocumentState()),
    [dispatch],
  );

  const loading = state?.loading ?? false;
  const error = state?.error ?? null;
  const message = state?.message ?? null;
  const success = state?.success ?? false;

  return {
    state: {
      loading,
      error,
      message,
      success,
      lastDeletedFileId: state?.lastDeletedFileId ?? null,
      lastStatus: state?.lastStatus ?? null,
    },
  
    isDeleteDialogOpen: loading,
    deleteDocument,
    clearState,
  };
}

